module.exports = __webpack_public_path__ + "img/instagram.796222bc.svg";